import * as React from 'react';
import Svg, {Path} from 'react-native-svg';

function DownIcon({color = '#FFFFFF'}: {color?: string}) {
  return (
    <Svg width={18} height={11} viewBox="0 0 18 11" fill="none">
      <Path
        d="M8.336 10.164l-7.5-7.5c-.39-.352-.39-.937 0-1.328.352-.352.937-.352 1.328 0L9 8.21l6.836-6.836c.351-.39.937-.39 1.328 0a.92.92 0 010 1.29l-7.539 7.5a.856.856 0 01-1.29 0z"
        fill={color}
      />
    </Svg>
  );
}

export default DownIcon;
